import React, { memo } from 'react';

import { getLiteral } from 'utils/getLiteral';

import RatesSectionBlock from './RatesSectionBlock';

const RatesDiscountsSectionHeader = memo(() => (
    <RatesSectionBlock
        className="rates-crud-section--discounts-intro"
        subtitle={getLiteral('helptext_apply_discounts_rates')}
    />
));

RatesDiscountsSectionHeader.displayName = 'RatesDiscountsSectionHeader';

export default RatesDiscountsSectionHeader;
